import {ReportConfig} from "../../schema";
import React from "react";
import UICheckbox from "../../ui/form/UICheckbox";
import ModalContent from "../../ui/modal/ModalContent";
import ModalButtons from "../../ui/modal/ModalButtons";
import PrimaryButton from "../../ui/PrimaryButton";
import gql from "graphql-tag";
import {useMutation} from "@apollo/client";
import {handleError, handleSuccess} from "../../utils/Apollo";

type Props = {
  config: ReportConfig
  onClose: () => void
}

export function ExportEventForm({config, onClose}: Props) {
  const [exportReport] = useMutation(exportMutation);

  const ids = new Set(
    config.event.filter(e => e.selected).map(e => e.id).concat(
      config.invoice.filter(e => e.selected).map(e => e.id)
    )
  )
  const [selectedIds, setSelectedIds] = React.useState<Set<string>>(ids);

  const handleOnChange = (id: string) => {
    if (selectedIds.has(id)) {
      selectedIds.delete(id);
      setSelectedIds(new Set(selectedIds));
    } else {
      selectedIds.add(id);
      setSelectedIds(new Set(selectedIds));
    }
  }

  const onClickExport = () => {
    exportReport({
      variables: {
        fields: Array.from(selectedIds)
      }
    }).then(() => {
      onClose();
      handleSuccess(`Export has been started. You will receive an email when it is ready.`)
    }, (apolloError) => handleError(apolloError));
  }


  return (
    <div className="text-sm">
      <ModalContent>
        <div className="border-b border-gray-light pb-6 pt-2">
          <h3 className="text-xl my-4 font-semibold">Event</h3>
          <div className="grid grid-cols-3 gap-y-2">
            {config.event.map((e) => (
              <UICheckbox key={e.id} id={e.id} checked={selectedIds.has(e.id)} onChange={handleOnChange}
                          label={e.title}/>
            ))}
          </div>
        </div>
        <div className="border-b border-gray-light pb-6 pt-2">
          <h3 className="text-xl my-4 font-semibold">Invoice</h3>
          <div className="grid grid-cols-3 gap-y-2">
            {config.invoice.map((e) => (
              <UICheckbox key={e.id} id={e.id} checked={selectedIds.has(e.id)} onChange={handleOnChange}
                          label={e.title}/>
            ))}
          </div>
        </div>
      </ModalContent>
      <ModalButtons>
        <PrimaryButton onClick={() => onClickExport()}>Export</PrimaryButton>
      </ModalButtons>
    </div>
  );
}

const exportMutation = gql`
  mutation ExportMutation($fields: [String!]!) {
    reportExportEvents(fields: $fields)
  }
`;
